import { __exportAll } from "../../_virtual/_rolldown/runtime.js";
//#region src/redux/view-port/reducers.ts
var reducers_exports = /* @__PURE__ */ __exportAll({ updateViewPort: () => updateViewPort });
var updateViewPort = (state, { payload }) => {
	state.viewPort.width = payload?.viewPort.width;
	state.viewPort.height = payload?.viewPort.height;
	state.viewPort.breakpoint = payload?.viewPort.breakpoint;
};
//#endregion
export { reducers_exports, updateViewPort };

//# sourceMappingURL=reducers.js.map